import React from 'react';
import herokulogo from './imgs/MyProjects/herokulogo.png';
import stockgraph from './imgs/MyProjects/stockgraph.svg';
import digitrecogizer from './imgs/MyProjects/digitrecoginzer.svg';
import revisionbank from './imgs/MyProjects/revisionbank.PNG';
import pythonlogosmall from './imgs/MyProjects/pythonlogo.svg';
import reactlogosmall from './imgs/MyProjects/reactlogo.svg';
import tensorflowlogosmall from './imgs/MyProjects/tensorflowlogo.png';
import mongdblogosmall from './imgs/MyProjects/mongodbsmall.png';
import flasklogosmall from './imgs/MyProjects/flasklogo.jfif';
import spacylogosmall from './imgs/MyProjects/spacylogo.png';
import pandaslogosmall from './imgs/MyProjects/pandaslogo.jfif';
import numpylogosmall from './imgs/MyProjects/numpylogo.png';
import seleniumlogosmall from './imgs/MyProjects/seleniumlogo.png';
import requestslogosmall from './imgs/MyProjects/requestslogo.png';
import beautifulsouplogosmall from './imgs/MyProjects/beautifulsouplogo.jfif';
import STEMRoadmap from './imgs/MyProjects/STEMRoadmap.svg';
import dockerlogo from './imgs/MyProjects/dockerlogo.svg';
import typescriptlogo from './imgs/MyProjects/typescriptlogo.png';
import aslevelsendersnap from './imgs/MyProjects/ASPhysicsLevelRevisionCard.PNG';
import NLBashsnap from './imgs/MyProjects/NLBashSnap.png';
import bashlogo from './imgs/MyProjects/bashlogosmall.png';

const RevisionBankText = () => (
  <div className="project-column-text">
    <h2 className="project-title">RevisionBank</h2>
    <p className="project-tech-label"><b>Made Using:</b></p>
    <div className="project-tech-icons">
      <img className="project-tech-icon" src={reactlogosmall} alt="React" />
      <img className="project-tech-icon" src={pythonlogosmall} alt="Python" />
      <img className="project-tech-icon" src={herokulogo} alt="Heroku" />
      <img className="project-tech-icon" src={mongdblogosmall} alt="MongoDB" />
      <img className="project-tech-icon" src={typescriptlogo} alt="TypeScript" /> 
      <img className="project-tech-icon project-tech-icon-bg-white" src={seleniumlogosmall} alt="Selenium" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={requestslogosmall} alt="Requests" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={beautifulsouplogosmall} alt="BeautifulSoup" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={flasklogosmall} alt="Flask" />
    </div>
    <p className="project-text-paragraph">
      <a href="https://revisionbank.org" target="_blank" rel="noreferrer" style={{ color: "var(--color-accent)", textDecoration: "underline" }}>RevisionBank</a> is a web application that provides and collects topic-specific questions for A-level subjects, emailing selected question papers to refer back to. This includes past papers, solution banks, and mark schemes.
      The RevisionBank tools cover Mathematics, Further Mathematics, and Physics, with active plans to expand into further subjects, exam boards, and key stages. The initial goal was to tackle the tsunami of Further Maths A-level homework in an ambitious attempt to automate my academic revision.
      Future features include a copyright-compliant search engine to discover papers, and a highly interactive user dashboard with study scheduling and structured note-taking.
    </p>
  </div>
);

const StemRoadmapText = () => (
  <div className="project-column-text">
    <h2 className="project-title">STEMRoadmap Startup Project</h2>
    <p className="project-tech-label"><b>Made Using:</b></p>
    <div className="project-tech-icons">
      <img className="project-tech-icon" src={pythonlogosmall} alt="Python" />
      <img className="project-tech-icon" src={reactlogosmall} alt="React" />
      <img className="project-tech-icon" src={herokulogo} alt="Heroku" />
      <img className="project-tech-icon" src={mongdblogosmall} alt="MongoDB" />
      <img className="project-tech-icon" src={spacylogosmall} alt="SpaCy" />
      <img className="project-tech-icon" src={typescriptlogo} alt="TypeScript" />  
      <img className="project-tech-icon" src={dockerlogo} alt="Docker" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={pandaslogosmall} alt="Pandas" />  
      <img className="project-tech-icon project-tech-icon-bg-white" src={flasklogosmall} alt="Flask" />
    </div>
    <p className="project-text-paragraph">
      STEMRoadMap is my first startup project attempt. The goal is to collect information from the internet and dynamically build a custom learning roadmap for any STEM subject, customized for students, undergraduates, or professional career switchers.
      The software integrates a suite of natural language processing (NLP) and machine learning methods. I succeeded in streamlining the data filtering pipeline, reducing the data collection and filtering latency from 7 minutes to 40 seconds.
      To support instant lookups in production, I implemented a robust caching database layers. Through this process, I self-taught complex deployment workflows on Heroku, and I am currently expanding our pipeline to utilize AWS serverless architecture.
    </p>
  </div>
);

const ASLevelSenderText = () => (
  <div className="project-column-text">
    <h2 className="project-title">AS Level Revision Card Scheduler</h2>
    <p className="project-tech-label"><b>Made Using:</b></p>
    <div className="project-tech-icons">
      <img className="project-tech-icon" src={herokulogo} alt="Heroku" />
      <img className="project-tech-icon" src={pythonlogosmall} alt="Python" />
      <img className="project-tech-icon" src={mongdblogosmall} alt="MongoDB" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={requestslogosmall} alt="Requests" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={flasklogosmall} alt="Flask" />
    </div>
    <p className="project-text-paragraph">
      AS Level Revision Card Scheduler is an application that schedules and emails custom, bite-sized revision cards to the user on an hourly basis, facilitating passive, continuous learning.
      This project was born out of a high-pressure 4-hour cramming session for AS Physics. Staring at textbooks wasn't working, and traditional paper revision cards felt tedious.
      To solve this, I designed a digital platform that securely stores cards and pushes them to my inbox at customizable intervals, making active-recall studying effortless and mobile.
    </p>
  </div>
);

const NLBashText = () => (
  <div className="project-column-text">
    <h2 className="project-title">NLBash Attention Transformer Model</h2>
    <p className="project-tech-label"><b>Made Using:</b></p>
    <div className="project-tech-icons">
      <img className="project-tech-icon" src={tensorflowlogosmall} alt="Tensorflow" />
      <img className="project-tech-icon" src={pythonlogosmall} alt="Python" />
      <img className="project-tech-icon" src={numpylogosmall} alt="NumPy" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={pandaslogosmall} alt="Pandas" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={bashlogo} alt="Bash" />
    </div>
    <p className="project-text-paragraph">
      NLBash was inspired by J.A.R.V.I.S from Iron Man, aiming to translate natural language voice prompts into executable system commands. Instead of hardcoding basic scripts, I trained an Attention-based Transformer sequence-to-sequence model to interpret intent.
      Currently, the model converts natural language English requests directly into standard bash commands. I am actively developing context-specific arguments and custom API triggers to enable robust, hands-free machine operations.
    </p>
  </div>
);

const StockgraphText = () => (
  <div className="project-column-text">
    <h2 className="project-title">Stock Forecasting & LSTM Sentiment Analysis</h2>
    <p className="project-tech-label"><b>Made Using:</b></p>
    <div className="project-tech-icons">
      <img className="project-tech-icon" src={pythonlogosmall} alt="Python" />
      <img className="project-tech-icon" src={reactlogosmall} alt="React" />
      <img className="project-tech-icon" src={tensorflowlogosmall} alt="Tensorflow" />
      <img className="project-tech-icon" src={mongdblogosmall} alt="MongoDB" />
      <img className="project-tech-icon" src={spacylogosmall} alt="SpaCy" />  
      <img className="project-tech-icon project-tech-icon-bg-white" src={pandaslogosmall} alt="Pandas" />  
      <img className="project-tech-icon project-tech-icon-bg-white" src={flasklogosmall} alt="Flask" />
    </div>
    <p className="project-text-paragraph">
      This predictive system was developed for my Extended Project Qualification, evaluating correlation using historical stock charts and causation via real-time sentiment analysis on financial news and social media.
      While the numerical regression using LSTMs was highly accurate, the NLP models faced out-of-vocabulary constraints. I overcame this limitation by transitioning to pretrained GloVe and BERT word embeddings, pairing them with attention-mechanism architectures to achieve excellent domain-specific text classification.
    </p>
  </div>
);

const DigitRecognizerText = () => (
  <div className="project-column-text">
    <h2 className="project-title">Digit Recognizer using Tensorflow CNN's</h2>
    <p className="project-tech-label"><b>Made Using:</b></p>
    <div className="project-tech-icons">
      <img className="project-tech-icon" src={pythonlogosmall} alt="Python" />
      <img className="project-tech-icon" src={tensorflowlogosmall} alt="Tensorflow" />
      <img className="project-tech-icon" src={numpylogosmall} alt="NumPy" />
      <img className="project-tech-icon" src={dockerlogo} alt="Docker" />
      <img className="project-tech-icon project-tech-icon-bg-white" src={pandaslogosmall} alt="Pandas" />
    </div>
    <p className="project-text-paragraph">
      Commonly known as the "Hello World" of image classification, this Convolutional Neural Network (CNN) project was my gateway to computer vision. To make the trained model practical and interactive, I packaged the model into a light REST API, containerized it using Docker, and configured a smooth local developer stack. This taught me core MLOps practices, preparing me to host future neural nets on Azure and AWS.
    </p>
  </div>
);

function Projects() {
  return (
    <div className="portfolio-section-dark">
      <h2 id="project" className="portfolio-section-title">
        <span style={{ color: "var(--color-accent)" }}>My</span> Projects
      </h2>
      
      <div className="projects-container">
        {/* RevisionBank */}
        <div className="project-row">
          <div className="project-column-media">
            <div className="project-img-wrapper">
              <img src={revisionbank} className="project-img" alt="RevisionBank Project Dashboard" />
            </div>
          </div>
          <RevisionBankText />
        </div>

        {/* STEMRoadmap */}
        <div className="project-row project-row-reverse">
          <div className="project-column-media">
            <div className="project-img-wrapper">
              <img src={STEMRoadmap} className="project-img" alt="STEMRoadmap Startup Architecture" />
            </div>
          </div>
          <StemRoadmapText />
        </div>

        {/* AS Level Revision Card Scheduler */}
        <div className="project-row">
          <div className="project-column-media">
            <div className="project-img-wrapper">
              <img src={aslevelsendersnap} className="project-img" alt="AS Physics Flashcard Interface" />
            </div>
          </div>
          <ASLevelSenderText />
        </div>

        {/* NLBash Attention Transformer */}
        <div className="project-row project-row-reverse">
          <div className="project-column-media">
            <div className="project-img-wrapper">
              <img src={NLBashsnap} className="project-img" alt="NLBash AI Console Output" />
            </div>
          </div>
          <NLBashText />
        </div>

        {/* Stock Forecasting & Sentiment Analysis */}
        <div className="project-row">
          <div className="project-column-media">
            <div className="project-img-wrapper">
              <img src={stockgraph} className="project-img" alt="Stock Market Regression Visualizations" />
            </div>
          </div>
          <StockgraphText />
        </div>

        {/* Digit Recognizer */}
        <div className="project-row project-row-reverse">
          <div className="project-column-media">
            <div className="project-img-wrapper">
              <img src={digitrecogizer} className="project-img" alt="Tensorflow Digit Recognizer" />
            </div>
          </div>
          <DigitRecognizerText />
        </div>
      </div>
    </div>
  );
}

export default Projects;